// external dependencies
import React from 'react'
import styled from '@emotion/styled'
import { object } from 'prop-types'

// css import
import 'style/layout.css'

// styled components
const AppWrap = styled.div`
	background: #241333;
	width: 100%;
	min-height: 100vh;
`

const Main = styled.main`
	max-width: 1200px;
`

const MapLayout = ({ children }) => (
	<AppWrap>
		<Main>{children}</Main>
	</AppWrap>
)

MapLayout.propTypes = {
	children: object.isRequired,
}

export default MapLayout
